<template functional>
    <div>&nbsp;</div>
</template>

<script>
    export default {
        name: 'empty',
    };
</script>
